import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Card, Flex, Typography } from 'antd'
import { path } from 'src/libs'
import { DividendListSection } from 'src/pages/finSystem/balanceSummary/reports/reportDividends/section'

export const ReportDividends = () => {
  const navigate = useNavigate()
  const { Title, Text } = Typography

  return (
    <Flex vertical gap="middle">
      <Breadcrumb
        items={[
          {
            title: (
              <Text
                style={{
                  cursor: 'pointer',
                  color: 'var(--color-primary)',
                  fontSize: 16,
                }}
                onClick={() => navigate(path.finSystem.balanceSummary.entry())}
              >
                Financial statement
              </Text>
            ),
          },
          {
            title: (
              <Text type="secondary" style={{ fontSize: 16 }}>
                Dividends
              </Text>
            ),
          },
        ]}
      />
      <Title level={1} style={{ marginBottom: 0 }}>
        Dividends
      </Title>
      <Card>
        <DividendListSection />
      </Card>
    </Flex>
  )
}
